// extracted by mini-css-extract-plugin
export default {"hed":"Ip","blend":"Jp","resultsBox":"Kp","left":"Lp","right":"Mp","center":"Np","base":"Op","milk":"Pp","text":"Qp","hyroxresult":"Rp","margin":"Sp"};
    if(module.hot) {
      // 1730991501910
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  